import request, { getAssetUrl } from './client';

// GET /api/hero -> [{ title, imgUrl, href, order }]
// Hero images fill the full-bleed 1920x1080 slider, so request them at that width.
export async function getHeroSlides() {
  const slides = await request('/hero');
  return slides.map((slide) => ({
    ...slide,
    imgUrl: getAssetUrl(slide.imgUrl, { width: 1920 }),
  }));
}

// GET /api/movies/now-showing -> [{ title, poster, showTimes, ... }]
// Poster cards render small (~280-380px wide even at 4-up), so 500px is plenty.
export async function getNowShowingMovies() {
  const movies = await request('/movies/now-showing');
  return movies.map((movie) => ({
    ...movie,
    poster: getAssetUrl(movie.poster, { width: 500 }),
  }));
}

// GET /api/movies/upcoming -> [{ title, poster, releaseDate, ... }]
export async function getUpcomingMovies() {
  const movies = await request('/movies/upcoming');
  return movies.map((movie) => ({
    ...movie,
    poster: getAssetUrl(movie.poster, { width: 500 }),
  }));
}